import { createApi } from '@reduxjs/toolkit/query/react';

import { createEntityAdapter } from '@reduxjs/toolkit';
import { get } from 'api';
import { networkBaseQuery } from '../queries';

const itemsAdapter = createEntityAdapter({
  selectId: (item) => item.id,
  sortComparer: false,
});

const itemsSelector = itemsAdapter.getSelectors();

export const companiesApi = createApi({
  reducerPath: 'companiesApi',
  baseQuery: networkBaseQuery,
  tagTypes: ['companies'],
  endpoints: (builder) => ({
    getCompanies: builder.query({
      query: ({ filters }) => ({
        url: 'organizations',
        params: {
          ...filters,
          perPage: 20,
        },
      }),
      transformResponse: (response) => ({
        meta: response.meta,
        ...itemsAdapter.addMany(itemsAdapter.getInitialState(), response.items),
        companies: [],
      }),
      serializeQueryArgs: ({ endpointName }) => endpointName,
      merge: (currentState, incomingState) => {
        itemsAdapter.addMany(currentState, itemsSelector.selectAll(incomingState));
      },
      providesTags: ['companies'],
    }),
    getCompaniesPreview: builder.query({
      async queryFn({ networkId, ...params }) {
        try {
          const response = await get(`collections/${networkId}/organizations_preview`, {
            params,
          });
          return { data: response.data };
        } catch (error) {
          return { error: error.message || 'Failed to fetch companies preview' };
        }
      },
      providesTags: ['companies'],
    }),
    getCompanyBySlug: builder.query({
      async queryFn({ companySlug, networkId }) {
        try {
          const response = await get(`organizations/${companySlug}?collection_id=${networkId}`);
          return { data: response.data };
        } catch (error) {
          return { error: error.message || 'Failed to fetch company data' };
        }
      },
    }),
  }),
});

export const {
  useLazyGetCompaniesQuery,
  useGetCompaniesQuery,
  useGetCompaniesPreviewQuery,
  useLazyGetCompaniesPreviewQuery,
  useGetCompanyBySlugQuery,
} = companiesApi;
